import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { getTransactionHistoryById } from "app/services/SearchService";
import Tooltip from "rc-tooltip";
import paginationFactory from "react-bootstrap-table2-paginator";

const CreditTransactionHistory = (props) => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(5);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [memId, setMemId] = useState(0);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [TransactionMode, setTransactionMode] = useState("Credit");

  useEffect(() => {
    loadTransaction();
  }, []);

  useEffect(() => {
    if (props.memberId !== memId) {
      const timeout = setTimeout(async () => {
        await loadTransaction();
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [props.memberId]);

  const remarksFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.narration}</div>}
      >
        <a href="#">{row.narration.substring(0, 10)}...</a>
      </Tooltip>
    );
  };

  const columns = [
    {
      dataField: "sln",
      text: "Transaction Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionDate",
      text: "Transaction Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionType",
      text: "Transaction Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "narration",
      text: "Remarks",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: remarksFormatter,
    },
    {
      dataField: "transactionMode",
      text: "Transaction Mode",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionAmount",
      text: "Transaction Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "leadgerBalance",
      text: "Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransaction = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      TransactionMode,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getTransactionHistoryById(props.memberId, query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(responseData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  // Rest of the code remains the same

  return (
    <>
      <div className="mb-3">
        <BootstrapTable
          hover
          remote
          keyField="uniqueIdentity"
          data={data}
          columns={columns}
          // pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
    </>
  );
};

export default CreditTransactionHistory;
